<mat-slide-toggle
  color="primary"
  [checked]="themesService.isDarkTheme"
  (toggleChange)="themesService.switchLightDarkTheme()"
  [labelPosition]="'before'">
  {{ sliderText }}
</mat-slide-toggle>
